import type { RuntimeConfig } from "nuxt/schema";
import type { Providers, PROVIDER_NAMES } from "../types/providers";
import { getHygienaOptions } from "./providers";

export const AUTH_PROVIDER_STORAGE_KEY = "Auth:Provider";

export const PROVIDERS: Providers = {
  hygiena: {
    validate: (config: RuntimeConfig) => {
      const multiTenant = $ck.utils.parseBoolean(config.public.MULTI_TENANT);
      if (!multiTenant) return false;

      if (!config.public.AUTH_OPTIONS?.hygiena?.appName || !config.public.AUTH_OPTIONS?.hygiena?.baseUrl) return false;

      const options = getHygienaOptions(config);

      return !!options.appName?.length && !!options.baseUrl?.length;
    },
    import: async () => (await import("../providers/hygiena-auth")).default,
  },
  "msal-browser": {
    validate: (config: RuntimeConfig) => {
      const multiTenant = $ck.utils.parseBoolean(config.public.MULTI_TENANT);
      if (multiTenant) return false;
      const requiredKeys = ["AZURE_AD_CLIENT_ID", "AZURE_AD_TENANT_ID"];

      return requiredKeys.every((key) => key in config.public);
    },
    import: async () => (await import("../providers/msal-browser")).default,
  },
};

export const PROVIDER_KEYS = Object.keys(PROVIDERS) as PROVIDER_NAMES[];
